var _defs, _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQaDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#ed0000;}.c{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.36,32.98c-.11-.16-.29-.25-.48-.25H3.11c-.19,0-.37.09-.48.25-.11.16-.13.36-.07.53l1.46,3.9c.08.23.3.38.54.38h38.86c.24,0,.46-.15.54-.38l1.46-3.9c.07-.18.04-.38-.07-.53ZM43.03,36.62H4.97l-1.02-2.73h40.1l-1.02,2.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95,33.89l1.02,2.73h38.05l1.02-2.73H3.95ZM25.96,35.84h-3.91c-.32,0-.58-.26-.58-.58s.26-.58.58-.58h3.91c.32,0,.58.26.58.58s-.26.58-.58.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64,14.58v-2.23c0-.7.57-1.27,1.27-1.27h28.17c.7,0,1.27.57,1.27,1.27v2.23H8.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.22,15.44H7.78v-3.09c0-1.18.96-2.13,2.13-2.13h28.17c1.18,0,2.13.96,2.13,2.13v3.09ZM9.5,13.72h29v-1.37c0-.23-.19-.42-.42-.42H9.91c-.23,0-.42.19-.42.42v1.37Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 14.57,
    width: 1.72,
    height: 18.14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.78,
    y: 14.57,
    width: 1.72,
    height: 18.14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.81,29.63c-.17,0-.34-.06-.47-.19-.28-.26-.29-.69-.03-.97l8.51-9.03c.26-.28.69-.29.97-.03.28.26.29.69.03.97l-8.51,9.03c-.14.14-.32.22-.5.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.87,23.86c-.17,0-.34-.06-.47-.18-.28-.26-.29-.69-.03-.97l4.51-4.84c.26-.28.69-.29.97-.03.28.26.29.69.03.97l-4.51,4.84c-.14.14-.32.22-.5.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaDashboard);
export default __webpack_public_path__ + "static/media/qa-dashboard.113c736a5d12ee2c157893da76b4209c.svg";
export { ForwardRef as ReactComponent };